import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=21c989d4&scoped=true&"
import script from "./Recipe.vue?vue&type=script&lang=js&"
export * from "./Recipe.vue?vue&type=script&lang=js&"
import style0 from "./Recipe.vue?vue&type=style&index=0&id=21c989d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c989d4",
  null
  
)

export default component.exports